import React from 'react';
import { Button } from 'client/shared/Button/NewButton';
import { useT } from 'client/i18n/hooks/useT';
import { useDynamicUrlPath } from 'hooks/useDynamicUrlPath';
import { Container, GridContainer, Section, SellingPoint } from './styles';
import { getSellingPoints } from './getSellingPoints';

export function SellingPoints() {
  const t = useT();
  const { path } = useDynamicUrlPath({ destinationPath: '/dashboard/money' });
  return (
    <Section>
      <Container>
        <h2>
          {t(
            'AdsByAnchorScreen.SellingPoints.Title',
            'Introducing a better way for podcasters to earn',
            'Ads by Anchor page selling points section title'
          )}
        </h2>
        <GridContainer>
          {getSellingPoints(t).map(({ svg, heading, copy }) => {
            return (
              <SellingPoint key={`selling-point-${heading}`}>
                {svg}
                <h3>{heading}</h3>
                <p>{copy}</p>
              </SellingPoint>
            );
          })}
        </GridContainer>
        <Button color="yellow" kind="link" href={path}>
          {t(
            'AdsByAnchorScreen.SellingPoints.GetStartedButtonLabel',
            'Get started',
            'Get started button text'
          )}
        </Button>
      </Container>
    </Section>
  );
}
